<template>
    <div class="title">
        <div class="t-left">
            <div class="l-top">
                <p class="text">{{ gettitle(title) }}</p>
                <p class="text2" v-if="extend">/</p>
                <p class="text2" v-if="extend">{{ extend }}</p>
                <div class="more-btn" @click="tomore" v-if="isMore">查看更多></div>
                <div class="select-cont" v-if="seclist && seclist.length">
                    <el-select v-model="selectVal" placeholder="请选择" @change="secchange">
                        <el-option
                        v-for="item in seclist"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                        size="mini">
                        </el-option>
                    </el-select>
                </div>
                <!-- <div class="change-type" v-if="changeText">
                    {{ changeText }}
                    <img src="@/assets/temimg15/change.png" alt="">
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import * as methods from './method.js'
export default {
    name: 'scopetitle.textTitle5',
    props: {
        title: {
            type: [String, Object],
            default: ""
        },
        isMore: {
            type: Boolean,
            default: false
        },
        seclist: {
            type: Array,
            default: () => []
        },
        index: {
            type: [Number, String],
            default: 0
        },
        changeText: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            extend: '',
            selectVal: ''
        };
    },
    watch: {
        seclist(n) {
            if (n && n.length) {
                this.selectVal = n[0].key
            }
        }
    },
    methods: {
        ...methods,
        secchange(e) {
            this.$emit('secchange', e, this.index)
        }
    },
    mounted() { },
};
</script>

<style scoped lang="scss">
@font-face {
    font-family: "YouSheBiaoTiHei";
    src: url("../../assets/fonts/YouSheBiaoTiHei.woff2");
}

.title {
    width: 435px;
    height: 40px;
}

.t-left {
    .l-top {
        width: 435px;
        height: 37.5px;
        background: url('@/assets/scopetitle/title1.png') no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding: 2px 0 0 40px;
        display: flex;
        align-items: center;

        .text {
            font-family: YouSheBiaoTiHei;
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
        }

        .text2 {
            margin-left: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #8798AC;
            line-height: 12px;
        }

        .more-btn {
            margin: 0 24px 0 auto;
            font-size: 14px;
            color: #51a0f4;
            cursor: pointer;
            pointer-events: auto;
        }
    }
    .select-cont {
        margin: 0 20px 0 auto;
        width: 90px;
    }
    .change-type {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #60A0FF;
        line-height: 15px;
        display: flex;
        align-items: center;
        margin: 0 21px 0 auto;
        cursor: pointer;
        img {
            width: 15px;
            height: 12px;
            margin-left: 8px;
        }
    }
}
</style>
<style lang="scss">
.select-cont {
    .el-input__inner {
        background: url(@/assets/temimg15/sec-bg.png) no-repeat;
        background-size: 100% 24px;
        background-position: center center;
        border: 0;
        color: #fff;
    }
}
</style>